<template>
  <div class="Crisis_Memcon_view">
    <el-descriptions class="margin-top" :column="4"  border>

      <el-descriptions-item>
        <template slot="label">
          姓名
        </template>
        {{ data.realName }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          学号
        </template>
        {{ data.userID }}

      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          心理辅导员
        </template>
        {{ data.teachID }}

      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          谈话时间
        </template>
        {{ data.talkTime }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          谈话地点
        </template>
        {{ data.talkAddress }}
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">
          初评危机状态
        </template>
        <!-- {{ data.FirstCrisis }} -->

        <span v-if="data.FirstCrisis == '1'"  style="color: red;">红色预警</span>
        <span v-else-if="data.FirstCrisis == '2'" style="color: rgba(252, 111, 68, 1);">橙色预警</span>
        <span v-else-if="data.FirstCrisis == '3'" style="color: rgba(255, 196, 0, 1);">黄色预警</span>
        <span v-else-if="data.FirstCrisis == '4'" style="color: #409EFF;">蓝色预警</span>
        <span v-else-if="data.FirstCrisis == '5'" style="color: #00f670;">绿色预警</span>
        <span v-else-if="data.FirstCrisis == '6'">无法确定</span>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          心理中心建议
        </template>
        <!-- {{ data.psychCentralSuggests }} -->

        <div v-for="item in data.psychCentralSuggests" :key="item">
          <span v-if="item == '1'">精神专科就医</span>
          <span v-if="item == '2'">心理咨询</span>
          <span v-if="item == '3'">心理危机干预</span>
          <span v-if="item == '4'">保密突破联系监护人</span>
          <span v-if="item == '5'">报警急救</span>
          <span v-if="item == '6'">严密守护</span>
          <span v-if="item == '7'">密切陪护</span>
          <span v-if="item == '8'">重点关注</span>
          <span v-if="item == '9'">适当关注</span>
          <span v-if="item == '10'">正常交流</span>
          <span v-if="item == '11'">其他</span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          严重情况突出表现
        </template>

        <span v-if="data.suicidalFlg == '1'">有</span>
        <span v-else-if="data.suicidalFlg == '2'">无</span>
        <span v-else-if="data.suicidalFlg == '3'">待确定</span>
      </el-descriptions-item>

      <!-- <el-descriptions-item>
        <template slot="label">
          严重情况突出表现
        </template>
      </el-descriptions-item> -->

      <el-descriptions-item>
        <template slot="label">
          关于伤害的情况
        </template>
        
        <!-- {{ data.suicidalFlg }} -->

        <span v-if="data.suicidalFlg == '1'">有</span>
        <span v-else-if="data.suicidalFlg == '2'">无</span>
        <span v-else-if="data.suicidalFlg == '3'">待确定</span>
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">
          发生时间
        </template>
        {{ data.suicidalDate }}
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">
          发生情况
        </template>
        {{ data.suicidalDetail }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          疑似重性精神障碍
        </template>

        <span v-if="data.psychosesFlg == '1'">有</span>
        <span v-else-if="data.psychosesFlg == '2'">无</span>
        <span v-else-if="data.psychosesFlg == '3'">待确定</span>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          疑似出现
        </template>
        <!-- {{ data.suspectedAppears }} -->

        <div v-for="item in data.suspectedAppears" :key="item">
          <span v-if="item == '1'">感知觉障碍</span>
          <span v-if="item == '2'">思维障碍</span>
          <span v-if="item == '3'">注意障碍</span>
          <span v-if="item == '4'">记忆障碍</span>
          <span v-if="item == '5'">定向力障碍</span>
          <span v-if="item == '6'">情感障碍</span>
          <span v-if="item == '7'">意志障碍</span>
          <span v-if="item == '8'">动作与行为障碍</span>
          <span v-if="item == '9'">意识障碍</span>
          <span v-if="item == '10'">自知力缺失</span>
 
        </div>



      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">
          发生时间
        </template>
        {{ data.psychosesDate }}
      </el-descriptions-item>

      <el-descriptions-item span="4"> 
        <template slot="label">
          发生情况
        </template>
        {{ data.psychosesDetail }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          谈话时间
        </template>

        {{ data.appearDate }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          谈话地点
        </template>
        {{ data.appearAddress }}
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">
          主要情况
        </template>

        {{ data.appearDetail }}

      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          上报领导情况
        </template>
        <!-- {{ data.reportLeaderFlg }} -->

        <span v-if="data.reportLeaderFlg == '1'">是</span>
        <span v-else-if="data.reportLeaderFlg == '2'">否</span>
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">
          详情
        </template>
        {{ data.reportLeaderDetail }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          与家长沟通情况
        </template>
        <!-- {{ data.parentFlg }} -->

        <span v-if="data.parentFlg == '1'">是</span>
        <span v-else-if="data.parentFlg == '2'">否</span>

      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">
          详情
        </template>
        {{ data.parentDetail }}

      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          就医情况
        </template>
        <!-- {{ data.hospitalFlg }} -->

        <span v-if="data.hospitalFlg == '1'">是</span>
        <span v-else-if="data.hospitalFlg == '2'">否</span>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          医院名称
        </template>
        {{ data.hospitalName }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          医院诊断为
        </template>
        {{ data.hospitalDetail }}

      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          服药情况
        </template>
        {{ data.medicineFlg }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          是否在心理中心咨询
        </template>

        <!-- {{ data.counsultFlg }} -->

        <span v-if="data.counsultFlg == '1'">是</span>
        <span v-else-if="data.counsultFlg == '2'">否</span>

      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          咨询开始时间
        </template>
        {{ data.counsultBegin }}
      </el-descriptions-item>

      <!-- <el-descriptions-item>
        <template slot="label">
          咨询开始时间
        </template>
      </el-descriptions-item> -->

      <el-descriptions-item>
        <template slot="label">
          咨询次数
        </template>
        {{ data.counsultTimes }}
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">
          是否推荐去心理中心
        </template>
        <!-- {{ data.recommendCounsultFlg }} -->
        <span v-if="data.recommendCounsultFlg == '1'">是</span>
        <span v-else-if="data.recommendCounsultFlg == '2'">否</span>
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">
          后续实际是否去了
        </template>
        <!-- {{ data.realityCounsultFlg }} -->

        <span v-if="data.realityCounsultFlg == '1'">是</span>
        <span v-else-if="data.realityCounsultFlg == '2'">否</span>
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">
          心理联络员配合工作情况
        </template>
        {{ data.contactWorkDetail }}
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">
          心理委员配合工作情况
        </template>
        {{ data.committWorkDetail }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          对接部门
        </template>
        {{ data.contactDeptName }}
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">
          对接情况
        </template>
        {{ data.otherTeacherDetail }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          多方会商
        </template>
        <span v-if="data.multiPartyFlg == '1'">是</span>
        <span v-else-if="data.multiPartyFlg == '2'">否</span>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          上次谈话后危机状态
        </template>
        <!-- {{ data.talkCrisisGrade }} -->
        <span v-if="data.talkCrisisGrade == '1'"  style="color: red;">红色预警</span>
        <span v-else-if="data.talkCrisisGrade == '2'" style="color: #ffdb00;">橙色预警</span>
        <span v-else-if="data.talkCrisisGrade == '3'" style="color: #fffb00;">黄色预警</span>
        <span v-else-if="data.talkCrisisGrade == '4'" style="color: #409EFF;">蓝色预警</span>
        <span v-else-if="data.talkCrisisGrade == '5'" style="color: #00f670;">绿色预警</span>
        <span v-else-if="data.talkCrisisGrade == '6'">无法确定</span>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          是否调整危机状态
        </template>
        <span v-if="data.adjustCrisisFlg == '1'">是</span>
        <span v-else-if="data.adjustCrisisFlg == '2'">否</span>
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">
          调整后危机状态
        </template>
        <span v-if="data.adjustCrisisGrade == '1'" style="color: red;">红色预警</span>
        <span v-else-if="data.adjustCrisisGrade == '2'" style="color: rgba(246, 109, 67, 1);">橙色预警</span>
        <span v-else-if="data.adjustCrisisGrade == '3'" style="color: rgba(255, 196, 0, 1);">黄色预警</span>
        <span v-else-if="data.adjustCrisisGrade == '4'" style="color: #409EFF;">蓝色预警</span>
        <span v-else-if="data.adjustCrisisGrade == '5'" style="color: #00f670;">绿色预警</span>
        <span v-else-if="data.adjustCrisisGrade == '6'">绿色预警</span>
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">
          咨询师调整状态
        </template>
        <span v-if="data.consultCheckAdjust == '1'"  style="color: red;">红色预警</span>
        <span v-else-if="data.consultCheckAdjust == '2'"  style="color: #ffdb00;">橙色预警</span>
        <span v-else-if="data.consultCheckAdjust == '3'"  style="color: #fffb00;">黄色预警</span>
        <span v-else-if="data.consultCheckAdjust == '4'"  style="color: #409EFF;">蓝色预警</span>
        <span v-else-if="data.consultCheckAdjust == '5'"  style="color: #00f670;">绿色预警</span>
        <span v-else-if="data.consultCheckAdjust == '6'">绿色预警</span>
      </el-descriptions-item>
    </el-descriptions>
    <div v-if="this.Global.pdroleid(1069) || this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
      <p style="padding: 20px;">风险监控员初核意见</p>
      <el-checkbox-group style="margin-left: 20px;" :disabled="disabled1" :max="3" v-model="shenhe.riskMonitorChecks">
        <el-checkbox label="1" name="type">信息不完整</el-checkbox>
        <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
        <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
        <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
      </el-checkbox-group>
      <el-input style="padding: 20px;width: 90%;" :disabled="disabled1" type="textarea" v-model="shenhe.riskMonitorCheckDetail"></el-input>
      <div v-if="this.Global.pdroleid(1069)" style="margin-left: 20px;">
        <el-button type="primary" @click="submit(1)">审核确认</el-button>
        <el-button type="primary" @click="submit(2)">审核驳回</el-button>
        <el-button v-if="stuBolConsultant" type="primary" @click="submit(3)">提交咨询师</el-button>
        <el-button v-else type="primary" @click="dialogVisible = true">绑定咨询师</el-button>
      </div>
    </div>

    <div v-if="this.Global.pdroleid(1063) || this.Global.pdroleid(1089)">
      <p style="padding: 20px;">心理辅导员</p>
        <el-checkbox-group style="margin-left: 20px;" :disabled="disabled2" :max="3" v-model="shenhe.consultChecks">
          <el-checkbox label="1" name="type">信息不完整</el-checkbox>
          <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
          <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
          <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
        </el-checkbox-group>
        <el-input style="padding: 20px;width: 90%;" type="textarea" :disabled="disabled2" v-model="shenhe.consultCheckDetail"></el-input>
        <div v-if="this.Global.pdroleid(1059)" style="margin-left: 20px;">
          <el-button type="primary" @click="submit(1)">审核确认</el-button>
          <el-button type="primary" @click="submit(2)">审核驳回</el-button>
          <el-button type="primary" @click="submit(3)">提交危机主管</el-button>
        </div>
    </div>

    <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
      <p style="padding: 20px;">危机调整</p>
      <el-radio-group style="margin-left: 20px;" v-model="shenhe.CriAdminAdjust">
        <el-radio style="color: #FF0808;" label="1">红色预警</el-radio>
        <el-radio style="color: #E6A707;" label="2">橙色预警</el-radio>
        <el-radio style="color: #A68F52;" label="3">黄色预警</el-radio>
        <el-radio style="color: rgba(0, 136, 255, 1);" label="4">蓝色预警</el-radio>
        <el-radio style="color: rgb(2 158 1);" label="5">绿色预警</el-radio>
      </el-radio-group>
      <p style="padding: 20px;">危机主管复核意见</p>
      <el-checkbox-group style="margin-left: 20px;" :disabled="disabled2" :max="3" v-model="shenhe.criAdminChecks">
        <el-checkbox label="1" name="type">信息不完整</el-checkbox>
        <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
        <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
        <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
      </el-checkbox-group>
      <el-input style="padding: 20px;width: 90%;" type="textarea" :disabled="disabled2" v-model="shenhe.criAdminCheckDetail"></el-input>
      <div v-if="this.Global.pdroleid(1068)" style="margin-left: 20px;">
        <el-button type="primary" @click="submit(1)">审核确认</el-button>
        <el-button type="primary" @click="submit(2)">审核驳回</el-button>
        <el-button type="primary" @click="submit(3)">提交中心主任</el-button>
      </div>
    </div>
    <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
      <p style="padding: 20px;">中心主任审核意见</p>
      <el-checkbox-group style="margin-left: 20px;" :disabled="disabled3" :max="3" v-model="shenhe.centerDirectorChecks">
        <el-checkbox label="1" name="type">信息不完整</el-checkbox>
        <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
        <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
        <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
      </el-checkbox-group>

      <el-input style="padding: 20px;width: 90%;" :disabled="disabled3" type="textarea" v-model="shenhe.centerDirectorCheckDetail"></el-input>

      <div v-if="this.Global.pdroleid(1070)" style="margin-left: 20px;">
        <el-button type="primary" @click="submit(1)">审核确认</el-button>
        <el-button type="primary" @click="submit(2)">审核驳回</el-button>
      </div>
    </div>

    <el-dialog title="绑定咨询师" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <el-select v-model="wuserID" filterable placeholder="请选择">
        <el-option v-for="(item,i) in selectAllConsultantdata" :key="i" :label="item.realName" :value="item.userID"></el-option>
      </el-select>
      <br>
      <el-button style="margin-top: 20px;" type="primary" @click="submit(3)">提交咨询师</el-button>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      wuserID:'',
      selectAllConsultantdata:[],
      dialogVisible:false,
      TalkNo: '',
      stuBolConsultant: '',
      KeyNo: '',
      data: [],
      RoleID: '',
      disabled1: true,
      shenhe: {
        riskMonitorChecks: [],//风险监控员审核意见
        riskMonitorCheckDetail: '',//风险监控员审核详细意见
        criAdminChecks: [],//危机主管审核意见
        criAdminCheckDetail: '',//危机主管审核详细意见
        centerDirectorChecks: [],//中心主任审核意见
        centerDirectorCheckDetail: '',//中心主任审核详细意见"
        consultChecks: [],//咨询师审核意见
        consultCheckDetail: '',//咨询师审核详细意见"
        CriAdminAdjust: '',//危机主管调整状态"
      },
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    submit(val) {
      this.$Http_Post('/DistressPrediction/ToExamine', {
        TalkNo: this.TalkNo, Type: "谈话记录", Operate: val, KeyNo: this.KeyNo,
        RiskMonitorChecks: this.shenhe.riskMonitorChecks,
        RiskMonitorCheckDetail: this.shenhe.riskMonitorCheckDetail,
        CriAdminChecks: this.shenhe.criAdminChecks,
        CriAdminCheckDetail: this.shenhe.criAdminCheckDetail,
        CenterDirectorChecks: this.shenhe.centerDirectorChecks,
        CenterDirectorCheckDetail: this.shenhe.centerDirectorCheckDetail,
        ConsultChecks: this.shenhe.consultChecks,
        ConsultCheckDetail: this.shenhe.consultCheckDetail,
        CriAdminAdjust: this.shenhe.CriAdminAdjust,
        UserId: this.data.userID,//学生
        ConsultantID:this.wuserID//咨询师
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.$router.push({
            path: '/Crisis/Crisis_Intervent'
          })
        }
      });
    },
  },
  mounted() {
    this.TalkNo = [this.$route.query.TalkNo][0];
    this.KeyNo = [this.$route.query.KeyNo][0];
    this.RoleID = sessionStorage.getItem('RoleID');
    if (this.Global.pdroleid(1069)) {
      this.disabled1 = false;
    } else if (this.Global.pdroleid(1068)) {
      this.disabled2 = false;
    } else if (this.Global.pdroleid(1070)) {
      this.disabled3 = false;
    }
    this.$Http_Post('/DistressPrediction/ToExamineData', { TalkNo: this.TalkNo,KeyNo:this.KeyNo}).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data;
        this.age = res.Data.age;
        this.sex = res.Data.sex;
        this.userId = res.Data.userId;
        this.stuBolConsultant = res.Data.stuBolConsultant;
        this.shenhe = {
          riskMonitorChecks: res.Data.riskMonitorChecks,//风险监控员审核意见
          riskMonitorCheckDetail: res.Data.riskMonitorCheckDetail,//风险监控员审核详细意见
          criAdminChecks: res.Data.criAdminChecks,//危机主管审核意见
          criAdminCheckDetail: res.Data.criAdminCheckDetail,//危机主管审核详细意见
          centerDirectorChecks: res.Data.centerDirectorChecks,//中心主任审核意见
          centerDirectorCheckDetail: res.Data.centerDirectorCheckDetail,//中心主任审核详细意见"
        }
      }
    });

    this.$Http_Post('/DistressPrediction/PrefabricatedTableData', { keyNo: this.KeyNo }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.age = res.Data.age;
        this.sex = res.Data.sex;
        this.userId = res.Data.userId;
        this.shenhe = {
          riskMonitorChecks: res.Data.riskMonitorChecks,//风险监控员审核意见
          riskMonitorCheckDetail: res.Data.riskMonitorCheckDetail,//风险监控员审核详细意见
          criAdminChecks: res.Data.criAdminChecks,//危机主管审核意见
          criAdminCheckDetail: res.Data.criAdminCheckDetail,//危机主管审核详细意见
          centerDirectorChecks: res.Data.centerDirectorChecks,//中心主任审核意见
          centerDirectorCheckDetail: res.Data.centerDirectorCheckDetail,//中心主任审核详细意见"
        }
      }
    });

    this.$Http_Post('/management/distressPrediction/selectAllConsultant', {  }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.selectAllConsultantdata = res.Data
      }
    });

  }
}

</script>

<style>
.Crisis_Memcon_view{width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Crisis_Memcon_view .el-descriptions{width: 98%;margin-left: 1%;padding-top: 20px;}
</style>